import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFunnel from './funnel';
import * as fromReferrals from './referrals';
import * as fromRoot from '../../reducers';

export interface AnalyticsState {
  funnel: fromFunnel.State;
  referrals: fromReferrals.State;
}

export interface State extends fromRoot.State {
  analytics: AnalyticsState;
}

export const reducers = {
  funnel: fromFunnel.reducer,
  referrals: fromReferrals.reducer,
};

export const getAnalyticsState = createFeatureSelector<AnalyticsState>(
  'analytics'
);

export const getFunnelState = createSelector(
  getAnalyticsState,
  state => state.funnel
);

export const getReferralsState = createSelector(
  getAnalyticsState,
  state => state.referrals
);

export const selectFunnel = createSelector(
  getFunnelState,
  fromFunnel.getFunnel
);
export const selectReferrals = createSelector(
  getReferralsState,
  fromReferrals.getReferrals
);
export const selectFunnelErrors = createSelector(
  getFunnelState,
  fromFunnel.getFunnelErrors
);
export const selectReferralsErrors = createSelector(
  getReferralsState,
  fromReferrals.getReferralsErrors
);
